module.exports = __webpack_public_path__ + "static/img/2027_phase_function_Paper_Points.e25cf09.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2027_phase_function_Paper_Points.png
// module id = 45Af
// module chunks = 0